export const unique = <T>(v: T, i: number, a: T[]): boolean => a.indexOf(v) === i;
export const extractFieldValues = <T, F extends keyof T>(array: T[], fields: F[]): { [f in F]: T[f][] } =>
  fields.reduce((acc, f) => ({ ...acc, [f]: array.map(obj => obj[f]).filter(unique) }), {}) as {
    [f in keyof T]: T[f][];
  };
